export enum RatingStatus {
  TO_DO = 'TO_DO',
  IN_PROGRESS = 'IN_PROGRESS',
  DONE_BY_SCOPE = 'DONE_BY_SCOPE',
  DONE = 'DONE',
  UNABLE_TO_REQUEST = 'UNABLE_TO_REQUEST',
}
